import { createContext } from "react";
import { GlContextProps } from "../interfaces/glConfiguration"

export const GlCodingContext = createContext<GlContextProps>({});
